import React, {useContext, useState} from "react";
import { PJContext } from "./pj-context"
import CONSTS from "./pj-constants";
import {PJJourneyNav} from "./pj-journey-nav";
import {InputField} from "./form-input-field";
import { FormContext } from "./form-context"
import {FormError} from "./form-error";


function PJAccountLogin(props) {
    const { state, dispatch, data } = useContext(PJContext);

    const [formState, setFormState] = useState({});

    const loginUser = () => {
        const form =  document.getElementById('rev-login-form');

        let formData = {
            email: form['email'].value,
            password: form['password'].value
        };

        let newFormsState = {...formState};
        setFormState(newFormsState);

        fetch("/purchase/ValidateLogin", {
            method: "POST",
            dataType: "JSON",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify(formData)
        })
            .then((resp) => {
                return resp.json()
            })
            .then((result) => {
                switch (result.status) {
                    case 'OK':
                        setFormState({...formState, errors:[]});
                        dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_7_ORDER_CONFIRMATION, existingCustomer:true} });
                        break;
                    case 'ERROR':
                        let newFormsState = {...formState};
                        newFormsState = {
                            errors : result.data
                        };
                        setFormState(newFormsState);
                        break;
                }

                console.log(result);

            })
            .catch((error) => {
                console.log(error, "Ajax request error")
            })
    };

    return  (
        <FormContext.Provider value={{ formState }}>
            <div className={"order-frame my-auto  journey-step " + props.current}>
                <div className="frame-content d-flex">
                    <div className="my-auto mx-auto checkout">
                        <h4 className="center">CHECKOUT</h4>
                        <p className="center">Please enter your MyREV details</p>
                        <div className="row cta">
                            <div className="col-sm-6 offset-sm-3 col-xs-8 offset-xs-2 my-auto text-right">
                                <form id="rev-login-form">
                                    <InputField name={'email'} label={"Email*"} />
                                    <InputField name={'password'} label={"Password"} type={'password'} />
                                    <FormError error={formState.errors} />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <PJJourneyNav
                    backClick={e => dispatch({type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_4_ACCOUNT}})}
                    continueClick={e => loginUser()}
                    continueLabel={'Submit'}
                />
            </div>
        </FormContext.Provider>
    );
}

export { PJAccountLogin };